import React from 'react';
import './css/style.scss';
import smallLogo from '../../../components/header/images/clirnetSmallLogo.png';
// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../common/common'
import LazyImage from '../../CustomLibraries/LazyImage';
function CtaCardV3({ data = '', customClass, callback }) {
  const { title, logo, description, button_text } = data;
  return (
    <div className={`w-100 ctaCardV3Box rounded d-flex flex-column ${customClass}`}>
      <div className="d-flex justify-content-between align-items-center mb-4 ctaCardTop">
        {title && <h2 className="fs-2 text-black fw-semibold text-start ctaCardTitle">{title}</h2>}
        {logo && (
          <div className="ctaCardLogo">
            <div className="ctaCardLogoIn">
              <LazyImage src={logo} alt="CTA Logo" logo />
            </div>
          </div>
        )}
      </div>

      {description && (
        <p className="fs-4 text-dark fw-normal text-start">{reactHtmlParser(description)}</p>
      )}
      {button_text && (
        <h4
          className="fs-4 bg-primary text-white fw-medium rounded text-center ctaLink"
          onClick={callback}
        >
          {button_text ?? 'click here'}
        </h4>
      )}
    </div>
  );
}

export default CtaCardV3;
